enum ProxyComponentName {
    /**
     * Содержимое модального окна с советами и обратной связью
     */
    VacancyAdvicesModal = 'VacancyAdvicesModal',

    /**
     * Маленький график по конверсии вакансии
     */
    VacancyConversionChartSmall = 'VacancyConversionChartSmall',

    /**
     * Карточка с рыночным уровнем дохода вакансии
     */
    SalaryMarketRangeCard = 'SalaryMarketRangeCard',
}

export default ProxyComponentName;
